import { FunctionComponent } from 'react'
import classNames from 'classnames'
import { Button as ButtonProps, ButtonUXType } from './Button.types'
import { Icon } from '../Icon/Icon'
import { Label } from '../Label/Label'
import { useActions } from 'src/hooks/useActions'
import './Button.scss'

export const Button: FunctionComponent<ButtonProps> = ({
  attributes,
  className,
  onClick: onClickProp
}) => {
  const { onClick } = useActions(attributes.actions)

  const onClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClickProp) {
      onClickProp(e)
    }
    onClick()
  }

  const buttonProps = {
    onClick: onClickHandler,
    disabled: attributes.actionsEnabled === false
  }

  const btnType = attributes.type.toLowerCase()
  const btnSize = attributes.size.toLowerCase()
  const buttonBaseClassName = classNames(
    'core-ux-button',
    `core-ux-button--${btnType}`,
    `core-ux-button--${btnSize}`
  )

  if (attributes.type === ButtonUXType.Icon) {
    return (
      <button
        data-testid="core-ux-button"
        className={classNames(
          buttonBaseClassName,
          'core-ux-button--icon',
          className
        )}
        {...buttonProps}>
        <Icon {...attributes.icon} />
      </button>
    )
  }

  return (
    <button
      data-testid="core-ux-button"
      className={classNames(buttonBaseClassName, className)}
      {...buttonProps}>
      <Label {...attributes.label} />
    </button>
  )
}
